<template>
  <div>
    <div class="backtop topPc" @click="toTop">
      <a
        ><img
          src="https://rj-1254002404.cos.ap-chengdu.myqcloud.com/website/img/backtop.png"
      /></a>
    </div>
    <div class="topPhone" @click="toTop">
      <a><img src="../assets/toTop.png" /></a>
    </div>
    <footer class="bottomArea">
      <div class="bootomTitle">
        <!-- <div class="left"><img src="../assets/logo2.png" /></div> -->
        <div class="left"><img src="../assets/logo3.png" /></div>
        <div class="right">
          <span class="firmName">采航（上海）贸易有限公司 </span>
        </div>
      </div>
      <div class="bottomLine"></div>
      <div class="info">
        <div class="left d-none d-md-block">
          <ul class="info-nav">
            <li class="info-item">
              <router-link class="info-link" to="/">首页</router-link>
            </li>
            <li class="info-item">
              <router-link class="info-link" to="/about">关于我们</router-link>
            </li>
            <li class="info-item">
              <router-link class="info-link" to="/product"
                >产品中心</router-link
              >
            </li>
            <li class="info-item">
              <router-link class="info-link" to="/support"
                >技术支持</router-link
              >
            </li>
            <li class="info-item">
              <router-link class="info-link" to="/news">新闻动态</router-link>
            </li>
            <li class="info-item">
              <router-link class="info-link" to="/contact"
                >联系我们</router-link
              >
            </li>
            <li class="info-item">
              <router-link class="info-link" to="/hire">人才招聘</router-link>
            </li>
          </ul>
        </div>
        <div class="midline d-none d-md-block"></div>
        <div class="right">
          <div>
            <p class="info-right-item">
              <img src="../assets/phone.png" />
              <span>电话：86-021-60953707,60953708,60953709</span>
            </p>
            <p class="info-right-item">
              <img src="../assets/email.png" />
              <span>邮箱：ast@astsciencecorp.com.cn</span>
            </p>
            <p class="info-right-item">
              <img src="../assets/address.png" />
              <span>地址：上海市嘉定区德富路1198号202室</span>
            </p>
          </div>
        </div>
      </div>
      <div class="bottomLine"></div>
      <div class="copyright container">
        <span><a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff;">沪(嘉)应急管危经许[2020]203943(Y)</a></span>
        <span><a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff;">沪ICP备2023019769号</a></span>
      </div>
      <div class="copyright container" style="justify-content: center;">
        <span>©2010-2023采航(上海)贸易有限公司版权所有</span>
      </div>
    </footer>
  </div>
</template>

<style>
/* 回到顶部 */
.backtop {
  position: fixed;
  bottom: 50px;
  right: 2%;
  z-index: 200;
}

.backtop a img {
  width: 80%;
}

.topPhone {
  display: none;
  position: fixed;
  bottom: 20px;
  right: 0;
  z-index: 200;
}

.topPhone a {
  display: block;
  width: 50px;
  height: 50px;
  color: transparent;
}

.topPhone a img {
  width: 50px;
  height: 50px;
}

/* 底部区域 */
.bottomArea {
  width: 100%;
  max-width: 1920px;
  background: url(../assets/db.png) no-repeat center;
  overflow: hidden;
  margin: 0 auto;
}

.bottomArea .bootomTitle,
.bottomArea .info,
.bottomArea .copyright {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bottomArea .bootomTitle {
  width: 64%;
  height: 6.625rem;
  padding-left: 1rem;
  margin-left: 20%;
  box-sizing: border-box;
}

.bottomArea .bootomTitle .left,
.bottomArea .bootomTitle .right {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 50%;
}

.bottomArea .bootomTitle .left img {
  /* max-width: 15rem;
  max-height: 3.25rem; */
  width: 18rem;
  height: 3.75rem;
}

.bottomArea .bootomTitle .right {
  line-height: 2.0625rem;
  font-size: 2.0625rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  padding-left: 10%;
  box-sizing: border-box;
}

.bottomArea .bottomLine {
  width: 100%;
  height: 1px;
  background: #ffffff;
  opacity: 0.61;
}

.bottomArea .info {
  justify-content: center;
  width: 64%;
  height: 12.5rem;
  margin-left: 20%;
}

@media (max-width: 1800px) {
  .bottomArea .info {
    width: 80%;
    margin-left: 10%;
  }

  .bottomArea .info .left {
    width: calc(37% - 0.5px) !important;
    justify-content: flex-end;
  }

  .bottomArea .bootomTitle {
    width: 70%;
    margin-left: 15%;
  }

  .bottomArea .bootomTitle .right {
    line-height: 1.875rem;
    font-size: 1.875rem;
    padding-left: 4%;
  }
}

@media (max-width: 1500px) {
  .bottomArea .info {
    width: 80%;
    margin-left: 10%;
  }

  .bottomArea .info .right {
    width: 56% !important;
    padding-left: 4% !important;
  }

  .bottomArea .bootomTitle {
    width: 74%;
    margin-left: 13%;
  }

  .bottomArea .bootomTitle .left {
    width: 39%;
  }

  .bottomArea .bootomTitle .right {
    width: 61%;
    line-height: 1.7rem;
    font-size: 1.7rem;
    padding-left: 5%;
  }
}

@media (max-width: 1200px) {
  .bottomArea .info {
    width: 100%;
    margin-left: 0;
  }

  .bottomArea .info .left {
    width: calc(40% - 0.5px) !important;
    margin-left: 5%;
  }

  .bottomArea .bootomTitle {
    width: 90%;
    margin-left: 5%;
  }

  .bottomArea .bootomTitle .right {
    width: 57%;
    line-height: 1.7rem;
    font-size: 1.7rem;
    padding-left: 5%;
  }
}

@media (max-width: 987px) {
  .bottomArea .info .left {
    width: calc(40% - 0.5px) !important;
    margin-left: 5%;
  }

  .info-link,
  .info-right-item {
    line-height: 1rem !important;
    font-size: 1rem !important;
  }

  .bottomArea .bootomTitle .right {
    width: 57%;
    line-height: 1.5rem;
    font-size: 1.5rem;
    padding-left: 5%;
  }
}

@media (max-width: 900px) {
  .topPc {
    display: none;
  }

  .topPhone {
    display: block;
  }

  .bottomArea .bootomTitle {
    height: 6rem;
  }
}


@media (max-width: 800px) {
  .bottomArea .bootomTitle {
    height: 5.5rem;
  }

  .bottomArea .bootomTitle .left {
    width: 60%;
    margin-bottom: 0;
  }

  .bottomArea .bootomTitle .left img {
    width: 81%;
  }

  .bottomArea .info .right {
    width: 100% !important;
    padding-left: 0 !important;
    align-items: center !important;
  }

  .bottomArea .bootomTitle .right {
    width: 57%;
    line-height: 1.1rem;
    font-size: 1.1rem;
    padding-left: 0;
    justify-content: center;
  }
}

@media (max-width: 500px) {
  .bottomArea .bootomTitle {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 4rem;
    margin-left: 0;
    padding-left: 0.625rem;
  }

  .bottomArea .bootomTitle .left {
    width: 60%;
    margin-bottom: 0;
  }

  .bottomArea .bootomTitle .right {
    display: none;
    justify-content: flex-start;
    width: 100%;
  }

  .bottomArea .bootomTitle {
    width: 98%;
    margin-left: 2%;
    padding-left: 0;
  }
  .bottomArea .bootomTitle .left img {
    width: 80%;
    height: 2.5rem;
  }

  .bottomArea .info .right {
    align-items: flex-start!important;
    width: 100% !important;
    padding-left: 2% !important;
  }

  .bottomArea .copyright span:last-of-type {
    margin-left: 0.7rem !important;
  }

  .bottomArea .info {
    width: 100%;
    height: 7rem;
  }

  .info-right-item {
    line-height: 1.1rem!important;
    font-size: 0.8rem!important;
    margin-bottom: 0.4rem!important;
  }

  .info-right-item img {
    width: 1.5rem!important;
    height: 1.5rem!important;
  }

  .info-right-item:last-of-type {
    margin-bottom: 0!important;
  }

  .bottomArea .copyright {
    /* height: 3rem!important; */
    height: 1.5rem!important;
    line-height: 0.75rem!important;
    font-size: 0.75rem!important;
    padding-left: 2%;
  }
}
.bottomArea .info .left,
.bottomArea .info .right {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: calc(50% - 0.5px);
}

.bottomArea .info .midline {
  width: 1px;
  height: 12.5rem;
  background: #ffffff;
  opacity: 0.61;
}

.bottomArea .info .info-nav {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  height: 200px;
  margin: 0;
}

.info-item {
  display: flex;
  align-items: center;
  width: 33%;
  height: 33%;
  padding-left: 1rem;
  padding-right: 1rem;
}

.info-link {
  line-height: 1.125rem;
  font-size: 1.25rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
}

.info-link:hover {
  font-weight: bold;
  color: #ffffff;
  text-decoration: none;
  outline: none;
}

.bottomArea .info .right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 10%;
  box-sizing: border-box;
}

.info-right-item {
  display: flex;
  align-items: center;
  line-height: 1.1875rem;
  font-size: 1.25rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  margin-bottom: 1.6875rem;
}

.info-right-item:last-of-type {
  margin-bottom: 0;
}

.info-right-item img {
  width: 1.875rem;
  height: 1.875rem;
  margin-right: 0.5625rem;
}

.bottomArea .copyright {
  justify-content: center;
  /* height: 3.3125rem; */
  height: 1.625rem;
  line-height: 0.9375rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.bottomArea .copyright span:last-of-type {
  line-height: 0.875rem;
  margin-left: 3rem;
}
</style>

<script>
export default {
  name: "bottomFooter",
  data() {
    return {};
  },

  methods: {
    toTop () {
      console.log("回到顶部");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
